// /////////////////////////////////////////////////////////////////////////////////////
//                           Copyright (c) 2025
//                                  RXO Inc.
//                          All Rights Reserved Worldwide
// 
// WARNING:  This program (or document) is unpublished, proprietary
// property of RXO Inc. and is to be maintained in strict confidence.
// Unauthorized reproduction, distribution or disclosure of this program
// (or document), or any program (or document) derived from it is
// prohibited by State and Federal law, and by local law outside of the U.S.
// /////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import messages from "../helpers/messages";

import Modal from "./Modal";

export const ForbiddenErrorModal = ({ open, message, closeModal }) => (
  <Modal
    title={messages.accessDenied.defaultMessage}
    open={open}
    handleClose={closeModal}
    titleClass="modal__title_light uppercase"
    bodyClass="border-top-grey px-24 pt-24"
    closeButtonClass="modal__close-button mr-16 mt-16"
  >
    <p
      data-testid="forbidden-error-modal"
      className="font-size-16 text-dim-grey pb-8"
    >
      {message}
    </p>
    <div className="grid fr">
      <button
        data-testid="ok-button"
        className="primary-button cursor-pointer univers-67-bold-cond short-button"
        onClick={closeModal}
      >
        {messages.ok.defaultMessage}
      </button>
    </div>
  </Modal>
);

export default ForbiddenErrorModal;
